import type { Goal } from "web_myplann/Goals/Types/GoalTypes";
import type { GoalListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type MapGoalListItemDtoParams = {
	dto: GoalListItemResponseDTO;
	dueIn?: string;
	completed?: boolean;
};

export const mapGoalListItemDto = ({
	dto,
	dueIn = "",
	completed,
}: MapGoalListItemDtoParams): Goal => ({
	id: String(dto.id ?? ""),
	name: dto.name ?? "",
	category: dto.investmentPlanCategoryType,
	status: dto.coveredState ?? null,
	totalValue: dto.targetAmount ?? 0,
	coveredAmount: dto.coveredAmount,
	dueIn,
	...(completed !== undefined && { completed }),
});
